import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/chevron-down_16.svg.ts
import { svg } from "lit";
var chevronDown16Svg = svg`
<svg width="16" height="16" viewBox="0 0 16 16" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6L8 10L12 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
export {
  chevronDown16Svg
};
//# sourceMappingURL=chevron-down_16.svg-BND54YF5.js.map
